import { CSS } from 'ui'

import Box from 'components/atomic/atoms/box'

type Light = 'lineBg' | 'bg'
type Dark = `${Light}Dark`

type Props = {
  [key in Light | Dark]?: CSS['background']
}

const Divider = ({ lineBg, lineBgDark, bg, bgDark }: Props) => (
  <Box
    relative
    css={{ pointerEvents: 'none', maxWidth: 2800, mx: 'auto', zIndex: 0 }}
  >
    <Box
      css={{
        height: 1,
        background: lineBg,
        '.dark &': {
          background: lineBgDark
        }
      }}
    />
    <Box
      css={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: -1,
        height: 300,
        overflow: 'hidden',
        '&::before': {
          position: 'absolute',
          content: '',
          zIndex: -10,
          bottom: '-50%',
          left: 0,
          right: 0,
          height: '100%',
          width: '120%',
          marginLeft: '-10%',
          marginRight: '-10%',
          maskImage: 'radial-gradient(rgba(0,0,0,0.7), transparent 70%)',
          backgroundBlendMode: 'overlay',
          background: bg,
          '.dark &': {
            background: bgDark
          }
        }
      }}
    />
  </Box>
)

export default Divider
